<template>
    <v-row justify="center">
        <v-dialog
            v-model="dialog"
            :persistent='true'
            width="60%"
            height="100%"
            class="modalDialog"
            no-click-animation
            >
            <div>
                <v-card class="cardWrap">
                    <CardTitle :title="page_title" />
                    <v-card-actions class="cardWrap__scroll">
                        <v-form
                            class="cardWrap__fromArea"
                            ref="form"
                            v-model="valid"
                            :lazy-validation="lazy"
                            id="form2"
                            >
                            <v-container>
                                 <v-row justify="space-around" no-gutters>
                                    <v-col cols="2" :class="labelObj">
                                        <div>ゴルフ場</div>
                                    </v-col>
                                    <v-col>
                                        <v-select
                                            class="px-3"
                                            disabled
                                            :items="golfSelectProps"
                                            item-value="golf_code"
                                            item-text="golf_name"
                                            v-model="input.golfCode"
                                            :rules='[rules.required]'
                                        />
                                    </v-col>
                                </v-row>
                                <v-row no-gutters class="my-2">
                                    <v-col cols="2" :class="labelObj">
                                        <div>公開対象</div>
                                    </v-col>
                                    <v-col cols="10" class="d-flex">
                                        <v-checkbox
                                            class="px-3 mt-0 pb-1"
                                            v-for="(d, index) in publicTargetSelection"
                                            :key="index"
                                            :label="d.code_name"
                                            :value="d.code"
                                            :rules="validateCheckbox"
                                            :hide-details="true"
                                            v-model="input.planMemberClass"
                                        />
                                    </v-col>
                                    <v-col cols="2"/>
                                    <v-col cols="10" v-show="!isValid" class="v-messages error--text pl-3 pt-2">
                                        {{ validateCheckbox[0] }}
                                    </v-col>
                                </v-row>
                                <v-row no-gutters>
                                    <v-col cols="2" :class="labelObj">
                                        <div>公開設定</div>
                                    </v-col>
                                    <v-col>
                                        <v-radio-group
                                            class="px-3"
                                            v-model="input.openFlag"
                                            row>
                                            <v-radio
                                                label="公開"
                                                value="1" />
                                            <v-radio
                                                label="非公開"
                                                value="0" />
                                        </v-radio-group>
                                    </v-col>
                                </v-row>
                                <v-row no-gutters>
                                    <v-col cols="2" :class="labelObj">
                                        <div>プランタイプ</div>
                                    </v-col>
                                    <v-col>
                                        <v-radio-group
                                            class="px-3"
                                            v-model="input.requestFlag"
                                            row>
                                            <v-radio
                                                label="通常プラン"
                                                value="0" />
                                            <v-radio
                                                label="リクエストプラン"
                                                value="1" />
                                        </v-radio-group>
                                    </v-col>
                                </v-row>
                                <v-row no-gutters>
                                    <v-col cols="2" :class="labelObj">
                                        <div>リクエスト予約の許可</div>
                                    </v-col>
                                    <v-col>
                                        <v-radio-group
                                            class="px-3"
                                            :disabled="disableApproval"
                                            v-model="input.requestApproval"
                                            row>
                                            <v-radio
                                                v-for="d in booleanObj"
                                                :key="d.id"
                                                :label="d.code_name"
                                                :value="d.code" />
                                        </v-radio-group>
                                    </v-col>
                                </v-row>
                                <v-row no-gutters>
                                    <v-col cols="2" :class="labelObj">
                                        <div>プラン名</div>
                                    </v-col>
                                    <v-col>
                                        <v-text-field
                                            class="px-3"
                                            v-model="input.planName"
                                            :rules="[rules.required]"
                                            id="form"
                                        />
                                    </v-col>
                                </v-row>
                                <v-row no-gutters>
                                    <v-col cols="2" :class="labelObj">
                                        <div>プラン作成期間</div>
                                    </v-col>
                                    <v-col cols="2">
                                        <!--
                                        # 注意事項

                                        以下の年月日の入力項目では、入力形式を YYYY-MM-DD としており、数字入力時にハイフンが自動で補完されるようになっている。
                                        （keyup イベント時に formatDate 関数を呼び出しそれを行っている）

                                        しかし、IMEが全角モードで数字を入力すると、上記の補完がうまく動作せず、入力した数字が二重で入ってしまう。
                                        例）2021と入力すると、2021-20-21と入ってしまう。

                                        この現象の回避策として、type に tel を指定することで、IMEモードがOFFになり、半角でのみ入力できるようにする。

                                        なお、この年月日は手入力のみ許可するため、type に date は指定していない。
                                        （date を指定するとカレンダーが表示されてしまう）
                                        -->
                                        <v-menu
                                            ref="menu"
                                            v-model="planStartMenu"
                                            :close-on-content-click="false"
                                            transition="scale-transition"
                                            offset-y min-width="290px"
                                        >
                                            <template v-slot:activator="{ on }">
                                                <v-text-field
                                                    class="px-3"
                                                    maxlength="10"
                                                    placeholder="0000-00-00"
                                                    inputmode="tel"
                                                    type="tel"
                                                    v-on="on"
                                                    v-model="formatedPlanStart"
                                                    @focus="focusDate(formatedPlanStart)"
                                                    @input="formatedPlanStart = $event"
                                                    @keyup.delete="deleteKeyUpPlanStart($event)"
                                                    @keyup="input.planValidDate = formatDate(formatedPlanStart)"
                                                    @keydown.tab.exact="planStartMenu = false"
                                                    :rules='[
                                                        rules.string_type,
                                                        rules.format_date,
                                                        rules.correctDate,
                                                        rules.required
                                                    ]'
                                                />
                                            </template>
                                            <v-date-picker
                                                ref="picker"
                                                v-model="formatedPlanStart"
                                                locale="jp-ja"
                                                :day-format="date => new Date(date).getDate()"
                                                min="1900-01-01"
                                                @input="planStartMenu = false"
                                            />
                                        </v-menu>
                                    </v-col>
                                    <span class="mt-5">~</span>
                                    <v-col cols="2">
                                        <!--
                                        # 注意事項

                                        以下の年月日の入力項目では、入力形式を YYYY-MM-DD としており、数字入力時にハイフンが自動で補完されるようになっている。
                                        （keyup イベント時に formatDate 関数を呼び出しそれを行っている）

                                        しかし、IMEが全角モードで数字を入力すると、上記の補完がうまく動作せず、入力した数字が二重で入ってしまう。
                                        例）2021と入力すると、2021-20-21と入ってしまう。

                                        この現象の回避策として、type に tel を指定することで、IMEモードがOFFになり、半角でのみ入力できるようにする。

                                        なお、この年月日は手入力のみ許可するため、type に date は指定していない。
                                        （date を指定するとカレンダーが表示されてしまう）
                                        -->
                                        <v-menu
                                            ref="menu"
                                            v-model="planValidMenu"
                                            :close-on-content-click="false"
                                            transition="scale-transition"
                                            offset-y min-width="290px"
                                        >
                                            <template v-slot:activator="{ on }">
                                                <v-text-field
                                                    class="px-3"
                                                    maxlength="10"
                                                    placeholder="0000-00-00"
                                                    inputmode="tel"
                                                    type="tel"
                                                    v-on="on"
                                                    v-model="formatedPlanValid"
                                                    @focus="focusDate(formatedPlanValid)"
                                                    @input="formatedPlanValid = $event"
                                                    @keyup.delete="deleteKeyUpPlanValid($event)"
                                                    @keyup="formatedPlanValid = formatDate(formatedPlanValid)"
                                                    @keydown.tab.exact="planValidMenu = false"
                                                    :rules='[
                                                        rules.string_type,
                                                        rules.format_date,
                                                        rules.correctDate,
                                                        rules.comparisonDate,
                                                        rules.required
                                                    ]'
                                                />
                                            </template>
                                            <v-date-picker
                                                ref="picker"
                                                v-model="formatedPlanValid"
                                                locale="jp-ja"
                                                :day-format="date => new Date(date).getDate()"
                                                min="1900-01-01"
                                                @input="planValidMenu = false"
                                            />
                                        </v-menu>
                                    </v-col>
                                </v-row>
                                <v-row no-gutters>
                                    <v-col cols="2" :class="labelObj">
                                        <div>公開期間（日時）</div>
                                    </v-col>
                                    <v-col cols="2">
                                        <!--
                                        # 注意事項

                                        以下の年月日の入力項目では、入力形式を YYYY-MM-DD としており、数字入力時にハイフンが自動で補完されるようになっている。
                                        （keyup イベント時に formatDate 関数を呼び出しそれを行っている）

                                        しかし、IMEが全角モードで数字を入力すると、上記の補完がうまく動作せず、入力した数字が二重で入ってしまう。
                                        例）2021と入力すると、2021-20-21と入ってしまう。

                                        この現象の回避策として、type に tel を指定することで、IMEモードがOFFになり、半角でのみ入力できるようにする。

                                        なお、この年月日は手入力のみ許可するため、type に date は指定していない。
                                        （date を指定するとカレンダーが表示されてしまう）
                                        -->
                                        <v-menu
                                            ref="menu"
                                            v-model="releaseStartMenu"
                                            :close-on-content-click="false"
                                            transition="scale-transition"
                                            offset-y min-width="290px"
                                        >
                                            <template v-slot:activator="{ on }">
                                                <v-text-field
                                                    class="px-3"
                                                    maxlength="10"
                                                    placeholder="0000-00-00"
                                                    inputmode="tel"
                                                    type="tel"
                                                    v-on="on"
                                                    v-model="formatedReleaseStart"
                                                    @focus="focusDate(formatedReleaseStart)"
                                                    @input="formatedReleaseStart = $event"
                                                    @keyup.delete="deleteKeyUpReleaseStart($event)"
                                                    @keyup="input.releaseValidDate = formatDate(formatedReleaseStart)"
                                                    @keydown.tab.exact="releaseStartMenu = false"
                                                    :rules='[
                                                        rules.string_type,
                                                        rules.format_date,
                                                        rules.correctDate,
                                                        rules.required
                                                    ]'
                                                />
                                            </template>
                                            <v-date-picker
                                                ref="picker"
                                                v-model="formatedReleaseStart"
                                                locale="jp-ja"
                                                :day-format="date => new Date(date).getDate()"
                                                min="1900-01-01"
                                                @input="releaseStartMenu = false"
                                            />
                                        </v-menu>
                                    </v-col>
                                    <v-col cols="2">
                                        <v-text-field
                                            class="px-3"
                                            maxlength="5"
                                            type="time"
                                            inputmode="tel"
                                            placeholder="00:00"
                                            v-model="formatedReleaseStartTime"
                                            :rules="[rules.correctTimeHours, rules.required]"
                                        />
                                    </v-col>
                                    <span class="mt-5">~</span>
                                    <v-col cols="2">
                                        <!--
                                        # 注意事項

                                        以下の年月日の入力項目では、入力形式を YYYY-MM-DD としており、数字入力時にハイフンが自動で補完されるようになっている。
                                        （keyup イベント時に formatDate 関数を呼び出しそれを行っている）

                                        しかし、IMEが全角モードで数字を入力すると、上記の補完がうまく動作せず、入力した数字が二重で入ってしまう。
                                        例）2021と入力すると、2021-20-21と入ってしまう。

                                        この現象の回避策として、type に tel を指定することで、IMEモードがOFFになり、半角でのみ入力できるようにする。

                                        なお、この年月日は手入力のみ許可するため、type に date は指定していない。
                                        （date を指定するとカレンダーが表示されてしまう）
                                        -->
                                        <v-menu
                                            ref="menu"
                                            v-model="releaseValidMenu"
                                            :close-on-content-click="false"
                                            transition="scale-transition"
                                            offset-y min-width="290px"
                                        >
                                            <template v-slot:activator="{ on }">
                                                <v-text-field
                                                    class="px-3"
                                                    maxlength="10"
                                                    placeholder="0000-00-00"
                                                    inputmode="tel"
                                                    type="tel"
                                                    v-on="on"
                                                    v-model="formatedReleaseValid"
                                                    @focus="focusDate(formatedReleaseValid)"
                                                    @input="formatedReleaseValid = $event"
                                                    @keyup.delete="deleteKeyUpReleaseValid($event)"
                                                    @keyup="formatedReleaseValid = formatDate(formatedReleaseValid)"
                                                    @keydown.tab.exact="releaseValidMenu = false"
                                                    :rules='[
                                                        rules.string_type,
                                                        rules.format_date,
                                                        rules.correctDate,
                                                        rules.comparisonDate,
                                                        rules.required
                                                    ]'
                                                />
                                            </template>
                                            <v-date-picker
                                                ref="picker"
                                                v-model="formatedReleaseValid"
                                                locale="jp-ja"
                                                :day-format="date => new Date(date).getDate()"
                                                min="1900-01-01"
                                                @input="releaseValidMenu = false"
                                            />
                                        </v-menu>
                                    </v-col>
                                    <v-col cols="2">
                                        <v-text-field
                                            class="px-3"
                                            maxlength="5"
                                            type="time"
                                            inputmode="tel"
                                            placeholder="00:00"
                                            v-model="formatedReleaseValidTime"
                                            :rules="[rules.correctTimeHours, rules.required]"
                                        />
                                    </v-col>
                                </v-row>
                                <v-row no-gutters class="align-center">
                                    <v-col cols="2" :class="labelObj">
                                        <div>キャンセルポリシー</div>
                                    </v-col>
                                    <v-col cols="3">
                                        <v-select
                                            class="px-3"
                                            v-model="input.cancelPolicy"
                                            :items="cancelPolicySelection"
                                            item-value="cancel_code"
                                            item-text="cancel_code_name"
                                            :rules="[rules.required]"
                                        />
                                    </v-col>
                                    <div style="flex: 0 0 10%;">
                                        <div>予約締切日</div>
                                    </div>
                                    <v-col cols="2">
                                        <v-text-field
                                            class="px-3"
                                            inputmode="tel"
                                            v-model="input.closingDays"
                                            maxlength="2"
                                        />
                                    </v-col>
                                    <v-col cols="1">日前</v-col>
                                    <div style="flex: 0 0 5%;">
                                        <div>時間</div>
                                    </div>
                                    <v-col>
                                        <v-text-field
                                            class="px-3"
                                            type="time"
                                            inputmode="tel"
                                            v-model="formatedClosingTime"
                                            validate-on-blur
                                            :rules='[rules.correctTimeHours]'
                                            maxlength="5"
                                        />
                                    </v-col>
                                </v-row>
                                <v-row no-gutters class="align-center">
                                    <v-col cols="2" :class="labelObj">
                                        <div>保証の有無</div>
                                    </v-col>
                                    <v-col cols="3">
                                        <v-radio-group
                                            class="px-3"
                                            :disabled="disableShare"
                                            v-model="input.shareFlag"
                                            row>
                                            <v-radio label="保証なし" value="1" />
                                            <v-radio label="保証あり" value="0" />
                                        </v-radio-group>
                                    </v-col>
                                    <div style="flex: 0 0 10%;">
                                        <div>シェア確定日</div>
                                    </div>
                                    <v-col cols="2">
                                        <v-text-field
                                            class="px-3 shrink"
                                            inputmode="tel"
                                            v-model="input.shareConfirmDays"
                                            maxlength="2"
                                        />
                                    </v-col>
                                    <v-col cols="1">日前</v-col>
                                    <div style="flex: 0 0 5%;">
                                        <div>時間</div>
                                    </div>
                                    <v-col>
                                        <v-text-field
                                            class="px-3 shrink"
                                            type="time"
                                            inputmode="tel"
                                            v-model="formatedShareConfirmTime"
                                            validate-on-blur
                                            :rules='[rules.correctTimeHours]'
                                            maxlength="5"
                                        />
                                    </v-col>
                                </v-row>
                                <v-row no-gutters>
                                    <v-col cols="2" :class="labelObj">
                                        <div>最少人数</div>
                                    </v-col>
                                    <v-col>
                                        <v-select
                                            class="px-3"
                                            v-model="input.playerMin"
                                            :items="countSelection"
                                            item-value="code"
                                            item-text="code_name"
                                            :rules="[rules.required]"
                                        />
                                    </v-col>
                                </v-row>
                                <v-row no-gutters>
                                    <v-col cols="2" :class="labelObj">
                                        <div>最大人数</div>
                                    </v-col>
                                    <v-col>
                                        <v-select
                                            class="px-3"
                                            v-model="input.playerMax"
                                            :items="calcMaxByPlayerMin"
                                            item-value="code"
                                            item-text="code_name"
                                            :rules="[rules.required]"
                                        />
                                    </v-col>
                                </v-row>
                                <v-row no-gutters>
                                    <v-col cols="2" :class="labelObj">
                                        <div>２B追加料金<small>(税込)</small></div>
                                    </v-col>
                                    <v-col cols="1" class="align-self-center text-center">
                                        平日
                                    </v-col>
                                    <v-col>
                                        <v-text-field
                                            class="px-3"
                                            inputmode="tel"
                                            maxlength="14"
                                            placeholder="0"
                                            v-model="input.addFee2bWeekday"
                                            v-on:focus="input.addFee2bWeekday = formatFoucsFee(input.addFee2bWeekday)"
                                            v-on:blur="input.addFee2bWeekday = formatBlurFee(input.addFee2bWeekday)"
                                            :rules="[rules.correctFee]"
                                            :disabled="ReturnTrueWhenPlayerMinIs2 && ReturnTrueWhenPlayerMaxIs2"
                                        />
                                    </v-col>
                                    <v-col cols="1" class="align-self-center">
                                        円
                                    </v-col>
                                    <v-col cols="1" class="align-self-center text-center">
                                        土日祝
                                    </v-col>
                                    <v-col>
                                        <v-text-field
                                            class="px-3"
                                            inputmode="tel"
                                            maxlength="14"
                                            placeholder="0"
                                            v-model="input.addFee2bWeekend"
                                            v-on:focus="input.addFee2bWeekend = formatFoucsFee(input.addFee2bWeekend)"
                                            v-on:blur="input.addFee2bWeekend = formatBlurFee(input.addFee2bWeekend)"
                                            :rules="[rules.correctFee]"
                                            :disabled="ReturnTrueWhenPlayerMinIs2 && ReturnTrueWhenPlayerMaxIs2"
                                            />
                                    </v-col>
                                    <v-col cols="1" class="align-self-center">
                                        円
                                    </v-col>
                                </v-row>
                                <v-row no-gutters>
                                    <v-col cols="2" :class="labelObj">
                                        <div>３B追加料金<small>(税込)</small></div>
                                    </v-col>
                                    <v-col cols="1" class="align-self-center text-center">
                                        平日
                                    </v-col>
                                    <v-col>
                                        <v-text-field
                                            class="px-3"
                                            inputmode="tel"
                                            maxlength="14"
                                            placeholder="0"
                                            v-model="input.addFee3bWeekday"
                                            v-on:focus="input.addFee3bWeekday = formatFoucsFee(input.addFee3bWeekday)"
                                            v-on:blur="input.addFee3bWeekday = formatBlurFee(input.addFee3bWeekday)"
                                            :rules="[rules.correctFee]"
                                            :disabled="ReturnTrueWhenPlayerMinIs3 && ReturnTrueWhenPlayerMaxIs3"
                                            />
                                    </v-col>
                                    <v-col cols="1" class="align-self-center">
                                        円
                                    </v-col>
                                    <v-col cols="1" class="align-self-center text-center">
                                        土日祝
                                    </v-col>
                                    <v-col>
                                        <v-text-field
                                            class="px-3"
                                            inputmode="tel"
                                            maxlength="14"
                                            placeholder="0"
                                            v-model="input.addFee3bWeekend"
                                            v-on:focus="input.addFee3bWeekend = formatFoucsFee(input.addFee3bWeekend)"
                                            v-on:blur="input.addFee3bWeekend = formatBlurFee(input.addFee3bWeekend)"
                                            :rules="[rules.correctFee]"
                                            :disabled="ReturnTrueWhenPlayerMinIs3 && ReturnTrueWhenPlayerMaxIs3"
                                            />
                                    </v-col>
                                    <v-col cols="1" class="align-self-center">
                                        円
                                    </v-col>
                                </v-row>
                                <!-- <selectInput label="ラウンド数" v-model="input.roundCode" :items="roundSelection"/> -->
                                <v-row no-gutters>
                                    <v-col cols="2" :class="labelObj">
                                        <div>ラウンド数</div>
                                    </v-col>
                                    <v-col>
                                        <v-select
                                            class="px-3"
                                            v-model="input.roundCode"
                                            :items="roundSelection"
                                            item-value="code"
                                            item-text="code_name"
                                            :rules="[rules.required]"
                                        />
                                    </v-col>
                                </v-row>
                                <v-row no-gutters>
                                    <v-col cols="2" :class="labelObj">
                                        <div>プレースタイル</div>
                                    </v-col>
                                    <v-col>
                                        <v-radio-group
                                            class="px-3"
                                            v-model="input.throughFlag"
                                            row>
                                            <v-radio
                                                v-for="d in playStyleSelection"
                                                :key="d.id"
                                                :label="d.code_name"
                                                :value="d.code" />
                                        </v-radio-group>
                                    </v-col>
                                </v-row>
                                <v-row no-gutters>
                                    <v-col cols="2" :class="labelObj">
                                        <div>コンペ</div>
                                    </v-col>
                                    <v-col>
                                        <v-radio-group
                                            class="px-3"
                                            v-model="input.competitionFlag"
                                            row>
                                            <v-radio
                                                v-for="d in competitionSelection"
                                                :key="d.id"
                                                :label="d.code_name"
                                                :value="d.code" />
                                        </v-radio-group>
                                    </v-col>
                                </v-row>
                                <!-- <selectInput label="カート種類" v-model="input.cartCode" :items="cartSelection"/> -->
                                <v-row no-gutters>
                                    <v-col cols="2" :class="labelObj">
                                        <div>カート種類</div>
                                    </v-col>
                                    <v-col>
                                        <v-select
                                            class="px-3"
                                            v-model="input.cartCode"
                                            :items="cartSelection"
                                            item-value="code"
                                            item-text="code_name"
                                            :rules="[rules.required]"
                                        />
                                    </v-col>
                                </v-row>
                                <v-row no-gutters v-if="planSetting.caddie_flag">
                                    <v-col cols="2" :class="labelObj">
                                        <div>キャディー付き</div>
                                    </v-col>
                                    <v-col>
                                        <v-radio-group
                                            class="px-3"
                                            v-model="input.caddieFlag"
                                            row>
                                            <v-radio label="つく" value="1" />
                                            <v-radio label="つかない" value="0" />
                                        </v-radio-group>
                                    </v-col>
                                </v-row>
                                <v-row no-gutters>
                                    <v-col cols="2" :class="labelObj">
                                        <div>レッスン</div>
                                    </v-col>
                                    <v-col>
                                        <v-radio-group
                                            class="px-3"
                                            v-model="input.lessonFlag"
                                            row>
                                            <v-radio label="つく" value="1" />
                                            <v-radio label="つかない" value="0" />
                                        </v-radio-group>
                                    </v-col>
                                </v-row>
                                <v-row no-gutters v-if="planSetting.meal_flag">
                                    <v-col cols="2" :class="labelObj">
                                        <div>食事</div>
                                    </v-col>
                                    <v-col>
                                        <v-radio-group
                                            class="px-3"
                                            v-model="input.mealFlag"
                                            row>
                                            <v-radio label="つく" value="1" />
                                            <v-radio label="つかない" value="0" />
                                        </v-radio-group>
                                    </v-col>
                                </v-row>
                                <v-row no-gutters v-if="planSetting.accommodation_flag">
                                    <v-col cols="2" :class="labelObj">
                                        <div>宿泊付き</div>
                                    </v-col>
                                    <v-col>
                                        <v-radio-group
                                            class="px-3"
                                            v-model="input.accommodationFlag"
                                            row>
                                            <v-radio label="つく" value="1" />
                                            <v-radio label="つかない" value="0" />
                                        </v-radio-group>
                                    </v-col>
                                </v-row>
                                <v-row no-gutters>
                                    <v-col cols="2" :class="labelObj">
                                        <div>特典</div>
                                    </v-col>
                                    <v-col>
                                        <v-radio-group
                                            class="px-3"
                                            v-model="input.benefitFlag"
                                            row>
                                            <v-radio label="つく" value="1" />
                                            <v-radio label="つかない" value="0" />
                                        </v-radio-group>
                                    </v-col>
                                    <v-col offset="5" cols="2">
                                        <v-btn
                                            :disabled="btn[2].isActive"
                                            @click="openBenefitModal"
                                            >特典設定</v-btn>
                                    </v-col>
                                </v-row>
                                <v-row no-gutters>
                                    <v-col cols="2" :class="labelObj">
                                        <div>優先度</div>
                                    </v-col>
                                    <v-col cols="3">
                                        <v-text-field
                                            v-model="input.displayPriority"
                                            class="px-3"
                                            type="number"
                                            />
                                    </v-col>
                                </v-row>
                                <v-row no-gutters>
                                    <v-col cols="2" :class="labelObj">
                                        <div>プラン詳細</div>
                                    </v-col>
                                    <v-textarea
                                        v-model="input.detail"
                                        no-resize
                                        class="px-3"></v-textarea>
                                </v-row>
                            </v-container>
                        </v-form>
                    </v-card-actions>
                    <v-card-actions>
                        <v-btn
                            :disabled="btn[5].isActive || deleteBtnDisable"
                            class="deletebtn"
                            text
                            @click="openRemoveOverlay">{{ deleteBtnName }}</v-btn>
                        <v-spacer></v-spacer>
                        <v-btn color="green darken-4" text @click="closeModal">閉じる</v-btn>
                        <v-btn
                            :disabled="btn[4].isActive || deleteBtnDisable"
                            color="green darken-4"
                            text
                            @click="openTimeModal">枠連携時間設定</v-btn>
                        <v-btn
                            :disabled="btn[3].isActive || deleteBtnDisable"
                            color="green darken-4"
                            text
                            @click="openFeeModal">料金設定</v-btn>
                        <v-btn
                            :disabled="btn[1].isActive || deleteBtnDisable"
                            color="green darken-4"
                            text v-if="addStatus"
                            @click="validateCheck">追加</v-btn>
                        <v-btn
                            :disabled="btn[1].isActive || deleteBtnDisable"
                            color="green darken-4"
                            text
                            v-else-if="changeStatus"
                            @click="validateCheck">更新</v-btn>
                    </v-card-actions>
                    <AddOverlay
                        page-name="プラン"
                        @processing="displayDialog"
                        @cancel="closeAddOverLay"
                        :process-result="process"
                        :OverlaySwitch="addOverlay"
                    />
                    <ChangeOverlay
                        page-name="プラン"
                        @processing="displayDialog"
                        @cancel="closeChangeOverLay"
                        :process-result="process"
                        :OverlaySwitch="changeOverlay"
                    />
                    <RemoveOverlay
                        page-name="プラン"
                        @processing="clickDelete"
                        @cancel="closeRemoveOverLay"
                        :process-result="process"
                        :OverlaySwitch="removeOverlay"
                    />
                </v-card>
            </div>
        </v-dialog>
        <PlanBenefitList
            :dialog="benefitDialog"
            :propsBenefitAdmin="passAdmin"
            :propsBenefitPlanId="passBenefitPlanID"
            :propsBenefitGolfName="passBenefitGolfName"
            @close="closeChild"
            :benefitGolfCourse="passBenefitGolfCourse"
            :propsBenefitPlanName="input.planName"
        />
        <PlanFeeList
            :dialog="feeDialog"
            :propsFeeAdmin="passAdmin"
            :propsFeePlanId="passFeePlanID"
            :propsFeeGolfName="passFeeGolfName"
            :propsFeePlanStart="input.planStartDate"
            :propsFeePlanEnd="input.planValidDate"
            @close="closeChild"
            :feeGolfCourse="passFeeGolfCourse"
            :propsFeePlanName="input.planName"
            :addD="input"
        />
        <PlanTimeList
            :dialog="timeDialog"
            :propsTimeAdmin="passAdmin"
            :propsTimePlanId="passTimePlanID"
            :propsTimeGolfName="passTimeGolfName"
            @close="closeChild"
            :timeGolfCourse="passTimeGolfCourse"
            :propsTimePlanName="input.planName"
        />
    </v-row>
</template>

<script>
import CardTitle from '@/components/module/CardTitle';
import validater from '@/lib/validater';
// モーダル
import PlanBenefitList from './PlanBenefitList';
import PlanFeeList from './PlanFeeList';
import PlanTimeList from './PlanTimeList';
import AddOverlay from '@/components/overlay/AddOverlay';
import ChangeOverlay from '@/components/overlay/ChangeOverlay';
import RemoveOverlay from '@/components/overlay/RemoveOverlay';

// mixins
import { authorityMixin } from '@/views/authorityMixin';
import { utilityMixin } from '@/mixins/utility';

// graphql
import {
    GET_DETAIL_PLAN_MASTER,
    GET_ADD_PLAN_INFO,
    UPDATE_PLAN_MASTER,
    DELETE_PLAN_MASTER,
    UPDATE_PLAN_DELETE_FLAG
} from '@/constants/plan';
import { SYNC_PLAN_CELLS } from '@/constants/cell_info';

export default {
    components: {
        CardTitle,
        PlanBenefitList,
        PlanFeeList,
        PlanTimeList,
        AddOverlay,
        ChangeOverlay,
        RemoveOverlay
    },
    mixins: [
        authorityMixin,
        utilityMixin
    ],
    props: {
        dialog: {
            type: Boolean
        },
        golfSelectProps: {
            type: Array
        }
    },
    data () {
        return {
            // 追加確認用ポップアップ表示に関する制御値
            addOverlay: false,
            // 変更確認用ポップアップ表示に関する制御値
            changeOverlay: false,
            benefitDialog: false,
            feeDialog: false,
            timeDialog: false,
            // 削除確認用ポップアップ表示に関する制御値
            removeOverlay: false,
            deleteSucccess: false,
            deleteBtnDisable: false,
            deleteBtnName: '削除',
            deleteStatus: '9',
            notUseSetting: '9',
            defaultUseSetting: '0',
            lazy: false,
            process: {
                // 処理結果
                result: '',
                // 処理結果メッセージ
                resultText: ''
            },
            // モーダルタイトル コンポーネントに渡す値：モーダルタイトル
            page_title: 'プラン詳細',
            // 必須項目に関するチェック値
            valid: true,
            // 会員追加： 入力項目の活性・非活性制御値
            addStatus: false,
            // 情報変更： 入力項目の活性・非活性制御値
            changeStatus: false,
            // プランID
            planId: '',
            // 公開対象
            publicTargetSelection: [],
            // キャンセルポリシーセレクトボックス
            cancelPolicySelection: [],
            // 人数選択
            countSelection: [],
            // ラウンド選択
            roundSelection: [],
            // カート選択
            cartSelection: [],
            // サム保障選択
            guaranteeSelection: [],
            // コンペ選択
            competitionSelection: [],
            // プレースタイル選択
            playStyleSelection: [],
            // 入力値
            input: {
                golfCode: '',
                planMemberClass: [],
                openFlag: '0',
                planName: '',
                cancelPolicy: '',
                closingDays: '',
                closingTime: '00:00',
                cancelValidDays: '',
                cancelValidTime: '',
                shareFlag: '0',
                shareConfirmDays: '',
                shareConfirmTime: '00:00',
                requestFlag: '0',
                requestApproval: '0',
                playerMin: '2',
                playerMax: '4',
                roundCode: '2',
                cartCode: '2',
                throughFlag: '0',
                guaranteeCode: '1',
                addFee2bWeekday: '',
                addFee2bWeekend: '',
                addFee3bWeekday: '',
                addFee3bWeekend: '',
                benefitFlag: '0',
                accommodationFlag: '0',
                mealFlag: '0',
                lessonFlag: '0',
                caddieFlag: '0',
                competitionFlag: '0',
                displayPriority: 0,
                detail: '',
                planStartDate: '',
                planValidDate: '',
                releaseStartDate: '',
                releaseStartTime: '',
                releaseValidDate: '',
                releaseValidTime: '',
                validFlag: 1
            },
            benefitFlag: '0',
            passAdmin: {},
            passBenefitGolfCourse: '',
            passTimeGolfCourse: '',
            passFeeGolfCourse: '',
            passBenefitGolfName: '',
            passTimeGolfName: '',
            passFeeGolfName: '',
            passBenefitPlanID: '',
            passTimePlanID: '',
            passFeePlanID: '',
            // 子コンポーネントのデータ件数
            benefitsCount: 0,
            feesCount: 0,
            timesCount: 0,
            inputChange: false,
            rules: {
                // 必須項目
                required: value => !!value || this.$t('error.validation.required.any'),
                // バリデーション
                string_type: value => validater.checkDateStringType(value) || this.$t('error.validation.num'),
                format_date: value => validater.checkDateFormat(value) || this.$t('error.validation.date.Correct'),
                correctDate: value => validater.checkCorrectDate(value) || this.$t('error.validation.date.Correct'),
                correctTime: value => validater.checkCorrectTime(value) || this.$t('error.validation.time.correct'),
                correctTimeHours: value => validater.checkCorrectTimeHours(value) || this.$t('error.validation.time.correct'),
                comparisonDate: value => this.checkStartDate(value) || this.$t('error.validation.date.comparison'),
                onlyNumber: value => validater.checkNum(value) || this.$t('error.validation.num'),
                correctFee: value => validater.checkFeeType(value) || this.$t('error.validation.required.incorrect')
            },
            dateFromTo: true,
            // ボタンの活性・非活性
            btn: [
                { element_id: '000', element_name: '画面', isActive: true },
                { element_id: '001', element_name: '登録', isActive: true },
                { element_id: '002', element_name: '特典設定', isActive: true },
                { element_id: '003', element_name: '料金設定', isActive: true },
                { element_id: '004', element_name: '枠連携時間設定', isActive: true },
                { element_id: '005', element_name: '削除', isActive: true }
            ],
            vue_id: 'SCR0025',
            labelObj: {
                'd-flex': true,
                'justify-center': true,
                'align-self-center': true
            },
            booleanObj: [
                { code_name: '不許可', code: '0' },
                { code_name: '許可', code: '1' }
            ],
            planSetting: [],
            planStartMenu: false,
            planValidMenu: false,
            releaseStartMenu: false,
            releaseValidMenu: false,
            isValid: true
        };
    },
    async created () {
    },
    watch: {
        input: {
            handler () {
                this.inputChange = true;
            },
            deep: true
        },
        /** ------------------------------------------------------------------
         * リクエストプランの場合、request_approvalを1(リクエスト予約を許可)にする。
         * また、share_flagを0(保証の有無を保証あり)にする。
         * ------------------------------------------------------------------- */
        'input.requestFlag' (val) {
            if (val === '1') {
                this.input.requestApproval = '1';
                this.input.shareFlag = '0';
            }
        },
        /** ----------------------------------------------------------------
         * 保証なしにした場合、request_approvalを0(リクエスト予約を不許可)にする。
         * ----------------------------------------------------------------- */
        'input.shareFlag' (val) {
            if (val === '1') {
                this.input.requestApproval = '0';
            }
        },
        'input.planMemberClass' () {
            if (this.input.planMemberClass.length === 0) {
                this.isValid = false;
                return;
            }
            this.isValid = true;
        }
    },
    computed: {
        formatedPlanStart: {
            get () {
                return this.input.planStartDate;
            },
            set (value) {
                value = this.addHyphen(value);
                this.input.planStartDate = value;
            }
        },
        formatedPlanValid: {
            get () {
                return this.input.planValidDate;
            },
            set (value) {
                value = this.addHyphen(value);
                this.input.planValidDate = value;
            }
        },
        formatedReleaseStart: {
            get () {
                return this.input.releaseStartDate;
            },
            set (value) {
                value = this.addHyphen(value);
                this.input.releaseStartDate = value;
            }
        },
        formatedReleaseStartTime: {
            get () {
                return this.input.releaseStartTime;
            },
            set (value) {
                if (value.length === 2) {
                    value = value + ':';
                }
                this.input.releaseStartTime = value;
            }
        },
        formatedReleaseValid: {
            get () {
                return this.input.releaseValidDate;
            },
            set (value) {
                value = this.addHyphen(value);
                this.input.releaseValidDate = value;
            }
        },
        formatedReleaseValidTime: {
            get () {
                return this.input.releaseValidTime;
            },
            set (value) {
                if (value.length === 2) {
                    value = value + ':';
                }
                this.input.releaseValidTime = value;
            }
        },
        formatedClosingTime: {
            get () {
                return this.input.closingTime;
            },
            set (value) {
                if (value.length === 2) {
                    value = value + ':';
                }
                this.input.closingTime = value;
            }
        },
        formatedShareConfirmTime: {
            get () {
                return this.input.shareConfirmTime;
            },
            set (value) {
                if (value.length === 2) {
                    value = value + ':';
                }
                this.input.shareConfirmTime = value;
            }
        },
        calcMaxByPlayerMin () {
            if (Number(this.input.playerMin) <= 3) {
                return this.countSelection.slice(Number(this.input.playerMin) - 1);
            } else {
                return this.countSelection.slice(3);
            }
        },
        ReturnTrueWhenPlayerMinIs2 () {
            return Number(this.input.playerMin) <= 2;
        },
        ReturnTrueWhenPlayerMaxIs2 () {
            return Number(this.input.playerMax) <= 2;
        },
        ReturnTrueWhenPlayerMinIs3 () {
            return Number(this.input.playerMin) <= 3;
        },
        ReturnTrueWhenPlayerMaxIs3 () {
            return Number(this.input.playerMax) <= 3;
        },
        disableApproval () {
            return this.input.requestFlag === '1' || this.input.shareFlag === '1';
        },
        disableShare () {
            return this.input.requestFlag === '1';
        },
        validateCheckbox () {
            return [this.input.planMemberClass.length > 0 || 'いずれか選択してください'];
        }
    },
    methods: {
        /** ----------------------------------------------
         * 初期化処理
         * ---------------------------------------------- */
        Initialize () {
            // システム設定で機能をオフにした場合に初期値を非表示にする
            let accommodationFlag = this.defaultUseSetting;
            let mealFlag = this.defaultUseSetting;
            let caddieFlag = this.defaultUseSetting;
            if (!this.planSetting.accommodation_flag) {
                accommodationFlag = this.notUseSetting;
            }
            if (!this.planSetting.accommodation_flag) {
                mealFlag = this.notUseSetting;
            }
            if (!this.planSetting.accommodation_flag) {
                caddieFlag = this.notUseSetting;
            }

            this.$set(this.input, 'golfCode', '');
            this.$set(this.input, 'planMemberClass', []);
            this.$set(this.input, 'openFlag', '0');
            this.$set(this.input, 'planName', '');
            this.$set(this.input, 'cancelPolicy', '');
            this.$set(this.input, 'closingDays', '');
            this.$set(this.input, 'closingTime', '00:00');
            this.$set(this.input, 'cancelValidDays', '');
            this.$set(this.input, 'cancelValidTime', '');
            this.$set(this.input, 'shareFlag', '0');
            this.$set(this.input, 'shareConfirmDays', '');
            this.$set(this.input, 'shareConfirmTime', '00:00');
            this.$set(this.input, 'requestFlag', '0');
            this.$set(this.input, 'requestApproval', '0');
            this.$set(this.input, 'playerMin', '2');
            this.$set(this.input, 'playerMax', '4');
            this.$set(this.input, 'cartCode', '2');
            this.$set(this.input, 'addFee2bWeekday', '');
            this.$set(this.input, 'addFee2bWeekend', '');
            this.$set(this.input, 'addFee3bWeekday', '');
            this.$set(this.input, 'addFee3bWeekend', '');
            this.$set(this.input, 'roundCode', '2');
            this.$set(this.input, 'throughFlag', '0');
            this.$set(this.input, 'guaranteeCode', '1');
            this.$set(this.input, 'benefitFlag', '0');
            this.$set(this.input, 'accommodationFlag', accommodationFlag);
            this.$set(this.input, 'mealFlag', mealFlag);
            this.$set(this.input, 'lessonFlag', '0');
            this.$set(this.input, 'caddieFlag', caddieFlag);
            this.$set(this.input, 'competitionFlag', '0');
            this.$set(this.input, 'displayPriority', 0);
            this.$set(this.input, 'detail', '');
            this.$set(this.input, 'planStartDate', '');
            this.$set(this.input, 'planValidDate', '');
            this.$set(this.input, 'releaseStartDate', '');
            this.$set(this.input, 'releaseStartTime', '');
            this.$set(this.input, 'releaseValidDate', '');
            this.$set(this.input, 'releaseValidTime', '');
            this.$set(this.input, 'validFlag', 1);
            const elements = document.getElementsByClassName('v-dialog--active');
            if (!elements || !elements.length) {
            // 要素が取得できなかった場合は終了
                return;
            }
            elements[0].scrollTop = 0;
            this.$refs.form.resetValidation();
        },
        /** ----------------------------------------------
         * プラン情報を取得
         * ---------------------------------------------- */
        async getDetailPlanMaster (golfCourse, modeStatus) {
            this.$store.commit('loading/setIsOpacityLoading', true);
            await this.$apollo.query({
                query: GET_DETAIL_PLAN_MASTER,
                fetchPolicy: 'no-cache',
                variables: {
                    golf_group_code: process.env.VUE_APP_GROUP_CODE,
                    golf_code: golfCourse,
                    plan_id: this.planId,
                    user_id: this.admin.user_id,
                    vue_id: this.vue_id,
                    element_id: ''
                }
            }).then(res => {
                // キャンセルポリシー取得
                this.cancelPolicySelection = res.data.getDetailPlanMaster.CancelPolicyList;
                if (modeStatus === true) {
                    this.input.cancelPolicy = this.cancelPolicySelection[0].cancel_code;
                }

                // プラン詳細取得
                const data = res.data.getDetailPlanMaster.PlanDetail;
                if (data.plan_name === null) {
                    return;
                }
                Object.keys(data).forEach(el => {
                    const camelCase = this.toCamelCase(el);
                    this.$set(this.input, camelCase, data[el]);
                });
                if (data.plan_start) {
                    this.input.planStartDate = data.plan_start;
                }
                if (data.plan_valid) {
                    this.input.planValidDate = data.plan_valid;
                }
                if (data.release_start) {
                    this.input.releaseStartDate = data.release_start.split(' ')[0];
                    this.input.releaseStartTime = data.release_start.split(' ')[1];
                }
                if (data.release_valid) {
                    this.input.releaseValidDate = data.release_valid.split(' ')[0];
                    this.input.releaseValidTime = data.release_valid.split(' ')[1];
                }
                this.input.addFee2bWeekday = this.formatFee(data.add_fee_2b_weekday);
                this.input.addFee2bWeekend = this.formatFee(data.add_fee_2b_weekend);
                this.input.addFee3bWeekday = this.formatFee(data.add_fee_3b_weekday);
                this.input.addFee3bWeekend = this.formatFee(data.add_fee_3b_weekend);
                this.timesCount = data.times_count;
                this.feesCount = data.fees_count;
                this.benefitsCount = data.benefits_count;
                this.$nextTick(function () {
                    this.inputChange = false;
                });

                this.input.planMemberClass = data.plan_member_class;

                // コードマスタの設定値を取得
                this.publicTargetSelection = res.data.getDetailPlanMaster.display_member_class;
                this.countSelection = res.data.getDetailPlanMaster.play_number;
                this.roundSelection = res.data.getDetailPlanMaster.round_type;
                this.guaranteeSelection = res.data.getDetailPlanMaster.guarantee_code;
                this.competitionSelection = res.data.getDetailPlanMaster.competition_flag;
                this.playStyleSelection = res.data.getDetailPlanMaster.through_flag;
                this.cartSelection = res.data.getDetailPlanMaster.cart_code;
                this.planSetting = res.data.getDetailPlanMaster.plan_setting;

                // 権限取得
                let opeList = res.data.getDetailPlanMaster.OperationAccessList;
                for (let list of opeList) {
                    this.btn.forEach(el => {
                        if (list.element_id === el.element_id) {
                            if (list.element_control === 0) {
                                el.isActive = true;
                            } else {
                                el.isActive = false;
                            }
                        }
                    });
                };
                this.$store.commit('loading/setIsOpacityLoading', false);
            });
        },
        /** ------------------------------
         * 追加時のプラン情報取得
         * ------------------------------ */
        async getAddPlanInfo (golfCourse, modeStatus) {
            this.$store.commit('loading/setIsOpacityLoading', true);
            await this.$apollo.query({
                query: GET_ADD_PLAN_INFO,
                fetchPolicy: 'no-cache',
                variables: {
                    golf_group_code: process.env.VUE_APP_GROUP_CODE,
                    golf_code: golfCourse,
                    user_id: this.admin.user_id,
                    vue_id: this.vue_id,
                    element_id: ''
                }
            }).then(res => {
                // キャンセルポリシー取得
                this.cancelPolicySelection = res.data.getAddPlanInfo.CancelPolicyList;
                if (modeStatus === true) {
                    this.input.cancelPolicy = this.cancelPolicySelection[0].cancel_code;
                }

                // コードマスタの設定値を取得
                this.publicTargetSelection = res.data.getAddPlanInfo.display_member_class;
                this.countSelection = res.data.getAddPlanInfo.play_number;
                this.roundSelection = res.data.getAddPlanInfo.round_type;
                this.guaranteeSelection = res.data.getAddPlanInfo.guarantee_code;
                this.competitionSelection = res.data.getAddPlanInfo.competition_flag;
                this.playStyleSelection = res.data.getAddPlanInfo.through_flag;
                this.cartSelection = res.data.getAddPlanInfo.cart_code;
                this.planSetting = res.data.getAddPlanInfo.plan_setting;

                // 権限取得
                let opeList = res.data.getAddPlanInfo.OperationAccessList;
                for (let list of opeList) {
                    this.btn.forEach(el => {
                        if (list.element_id === el.element_id) {
                            if (list.element_control === 0) {
                                el.isActive = true;
                            } else {
                                el.isActive = false;
                            }
                        }
                    });
                };
                this.$store.commit('loading/setIsOpacityLoading', false);
            });
        },
        /** ----------------------------------------------
         * キャメルケースに変換
         * ---------------------------------------------- */
        toCamelCase (str) {
            return str.split('_').map((str, index) => {
                if (index === 0) {
                    return str.toLowerCase();
                }
                return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
            }).join('');
        },
        /** --------------------------------------------
         * 公開日の日付チェック
         * -------------------------------------------- */
        checkStartDate (endDate) {
            if (!this.input.releaseStartDate) {
                return true;
            } else if (endDate) {
                let startDate = this.input.releaseStartDate.replace(/-/g, '');
                endDate = endDate.replace(/-/g, '');
                if (Number(startDate) <= Number(endDate)) {
                    return true;
                }
            } else {
                return false;
            }
        },
        /** ----------------------------------------------
         * 入力値を取得する。
         * ---------------------------------------------- */
        getInput () {
            // システム設定で機能をオフにした場合に初期値を非表示にする
            let accommodationFlag = this.input.accommodationFlag;
            let mealFlag = this.input.mealFlag;
            let caddieFlag = this.input.caddieFlag;
            if (!this.planSetting.accommodation_flag) {
                accommodationFlag = this.notUseSetting;
            }
            if (!this.planSetting.accommodation_flag) {
                mealFlag = this.notUseSetting;
            }
            if (!this.planSetting.accommodation_flag) {
                caddieFlag = this.notUseSetting;
            }

            return {
                golf_code: this.input.golfCode,
                plan_name: this.input.planName,
                plan_member_class: this.input.planMemberClass,
                open_flag: this.input.openFlag,
                closing_days: this.input.closingDays,
                closing_time: this.input.closingTime,
                cancel_policy: this.input.cancelPolicy,
                cancel_valid_days: this.input.cancelValidDays,
                cancel_valid_time: this.input.cancelValidTime,
                share_flag: this.input.shareFlag,
                share_confirm_days: this.input.shareConfirmDays,
                share_confirm_time: this.input.shareConfirmTime,
                request_flag: this.input.requestFlag,
                request_approval: this.input.requestApproval,
                player_min: this.input.playerMin,
                player_max: this.input.playerMax,
                guarantee_code: this.input.guaranteeCode,
                add_fee_2b_weekday: this.feeChangeFormat(this.input.addFee2bWeekday),
                add_fee_2b_weekend: this.feeChangeFormat(this.input.addFee2bWeekend),
                add_fee_3b_weekday: this.feeChangeFormat(this.input.addFee3bWeekday),
                add_fee_3b_weekend: this.feeChangeFormat(this.input.addFee3bWeekend),
                round_code: this.input.roundCode,
                through_flag: this.input.throughFlag,
                competition_flag: this.input.competitionFlag,
                cart_code: this.input.cartCode,
                caddie_flag: caddieFlag,
                lesson_flag: this.input.lessonFlag,
                meal_flag: mealFlag,
                accommodation_flag: accommodationFlag,
                benefit_flag: this.input.benefitFlag,
                detail: this.input.detail,
                plan_start: this.input.planStartDate,
                plan_valid: this.input.planValidDate,
                release_start: this.input.releaseStartDate + ' ' + this.input.releaseStartTime,
                release_valid: this.input.releaseValidDate + ' ' + this.input.releaseValidTime,
                display_priority: this.input.displayPriority,
                plan_id: this.planId
            };
        },
        /** ----------------------------------------------
         * 更新処理
         * ---------------------------------------------- */
        updatePlanMaster () {
            return this.$apollo.mutate({
                mutation: UPDATE_PLAN_MASTER,
                variables: { planMasterInput: this.getInput() }
            }).then(res => {
                const result = res.data.updatePlanMaster.result;
                if (result === 1) {
                    return result;
                } else {
                    throw new Error('エラーが発生しました。');
                }
            }).catch(error => {
                this.error = error;
            });
        },
        /** ----------------------------------------------
         * 物理削除処理
         * ---------------------------------------------- */
        deletePlanMaster () {
            return this.$apollo.mutate({
                mutation: DELETE_PLAN_MASTER,
                variables: {
                    plan_id: this.planId
                }
            }).then(res => {
                const result = res.data.deletePlanMaster.result;
                if (result === 1) {
                    return result;
                } else {
                    throw new Error('エラーが発生しました。');
                }
            }).catch(error => {
                this.error = error;
            });
        },
        /** ----------------------------------------------
         * 論理削除API実行
         * ---------------------------------------------- */
        upadatePlanDeleteFlag () {
            return this.$apollo.mutate({
                mutation: UPDATE_PLAN_DELETE_FLAG,
                variables: {
                    plan_id: this.planId
                }
            }).then(res => {
                const result = res.data.updatePlanDeleteFlag.result;
                const reserveNoList = res.data.updatePlanDeleteFlag.reserveNoList;
                if (result === 1) {
                    return result;
                } else {
                    if (reserveNoList) {
                        this.error = '予約受付中のデータがあるため削除できません。\n予約番号：' + reserveNoList.toString();
                    } else {
                        throw new Error('エラーが発生しました。');
                    }
                }
            }).catch(error => {
                this.error = error;
            });
        },
        /** ----------------------------------------------
         * 削除ボタンクリック処理
         * ---------------------------------------------- */
        async clickDelete () {
            let res = await this.upadatePlanDeleteFlag();
            this.process.result = res;
            if (this.process.result === 1) {
                this.deleteSucccess = true;
                this.process.resultText = this.$t('result.success.remove');
            } else {
                this.process.resultText = this.error;
            }
        },
        openRemoveOverlay () {
            this.removeOverlay = true;
        },
        /** ----------------------------------------------
         * 枠連携処理
         * ---------------------------------------------- */
        syncPlanCells () {
            return this.$apollo.mutate({
                mutation: SYNC_PLAN_CELLS,
                variables: {
                    golf_group_code: process.env.VUE_APP_GROUP_CODE,
                    golf_code: this.input.golfCode,
                    plan_id: this.planId
                }
            }).then(res => {
                return res.data.SyncPlanCells.result;
            });
        },
        /** ----------------------------------------------
         * ダイアログ処理
         * ---------------------------------------------- */
        async displayDialog () {
            const result = await this.updatePlanMaster();
            if (!result) return;
            if (this.addStatus) {
                this.addOverlay = false;
            } else if (this.changeStatus) {
                this.changeOverlay = false;
            }
            await this.syncPlanCells();
            this.Initialize();
            this.$refs.form.resetValidation();
            this.$emit('close');
        },
        /** ----------------------------------------------
         * 日付フォーマット処理
         * ---------------------------------------------- */
        deleteKeyUpPlanStart (event) {
            this.formatedPlanStart = this.formatDate(this.formatedPlanStart);
            this.formatedPlanStart = this.deleteKeyDelete(event);
        },
        deleteKeyUpPlanValid (event) {
            this.formatedPlanValid = this.formatDate(this.formatedPlanValid);
            this.formatedPlanValid = this.deleteKeyDelete(event);
        },
        deleteKeyUpReleaseStart (event) {
            this.formatedReleaseStart = this.formatDate(this.formatedReleaseStart);
            this.formatedReleaseStart = this.deleteKeyDelete(event);
        },
        /** ----------------------------------------------
         * 日付フォーマット処理
         * ---------------------------------------------- */
        deleteKeyUpReleaseValid (event) {
            this.formatedReleaseValid = this.formatDate(this.formatedReleaseValid);
            this.formatedReleaseValid = this.deleteKeyDelete(event);
        },
        /** ----------------------------------------------
         * チェック処理
         * ---------------------------------------------- */
        validateCheck () {
            if (this.$refs.form.validate()) {
                if (this.addStatus) {
                    this.addOverlay = true;
                } else if (this.changeStatus) {
                    this.changeOverlay = true;
                }
            } else {
                const elements = document.getElementsByClassName('v-dialog--active');
                if (!elements || !elements.length) {
                // 要素が取得できなかった場合は終了
                    return;
                }
                elements[0].scrollTop = 0;
            }
        },
        /** ----------------------------------------------
         * 金額フォーマット処理
         * ---------------------------------------------- */
        feeChangeFormat (fee) {
            if (!fee) {
                return '0';
            } else {
                fee = Number(fee.replace(/,/g, ''));
                if (fee >= 1) {
                    return String(fee);
                } else {
                    return '0';
                }
            }
        },
        /** ----------------------------------------------
         * 特典一覧を表示する
         * ---------------------------------------------- */
        async openBenefitModal () {
            this.passBenefitGolfCourse = this.input.golfCode;
            this.passBenefitPlanID = this.planId;
            this.benefitDialog = true;
        },
        /** ----------------------------------------------
         * 金額一覧を表示する
         * ---------------------------------------------- */
        async openFeeModal () {
            this.passFeeGolfCourse = this.input.golfCode;
            this.passFeePlanID = this.planId;
            this.feeDialog = true;
        },
        /** ----------------------------------------------
         * 枠連携一覧を表示する
         * ---------------------------------------------- */
        async openTimeModal () {
            this.passTimeGolfCourse = this.input.golfCode;
            this.passTimePlanID = this.planId;
            this.timeDialog = true;
        },
        /** ----------------------------------------------
         * 子のモーダルを閉じる
         * ---------------------------------------------- */
        closeChild (dataCount) {
            if (dataCount[0] === 'benefits_count') {
                this.benefitsCount = dataCount[1];
            } else if (dataCount[0] === 'fees_count') {
                this.feesCount = dataCount[1];
            } else if (dataCount[0] === 'times_count') {
                this.timesCount = dataCount[1];
            }
            this.timeDialog = false;
            this.feeDialog = false;
            this.benefitDialog = false;
            this.addStatus = false;
            this.changeStatus = true;
            this.passBenefitPlanID = '';
            this.passTimePlanID = '';
            this.passFeePlanID = '';
            // this.getDetailPlanMaster();
        },
        /** ----------------------------------------------
         * 追加ダイアログを閉じる
         * ---------------------------------------------- */
        closeAddOverLay () {
            this.process.result = '';
            this.addOverlay = false;
        },
        /** ----------------------------------------------
         * 変更ダイアログを閉じる
         * ---------------------------------------------- */
        closeChangeOverLay () {
            this.process.result = '';
            this.changeOverlay = false;
        },
        /** ----------------------------------------------
         * 削除ダイアログを閉じる
         * ---------------------------------------------- */
        closeRemoveOverLay () {
            this.process.result = '';
            this.removeOverlay = false;
            if (this.deleteSucccess) {
                this.Initialize();
                this.$refs.form.resetValidation();
                this.deleteSucccess = false;
                this.$emit('close');
            }
        },
        /** ----------------------------------------------
         * このモーダルを開く処理
         * ---------------------------------------------- */
        async ModalControl (admin, planId, golfCourse, golfName, ModeStatus) {
            this.admin = admin;
            this.passAdmin = this.admin;
            this.planId = planId;
            this.passBenefitGolfName = golfName;
            this.passTimeGolfName = golfName;
            this.passFeeGolfName = golfName;

            if (ModeStatus === false) {
                this.addStatus = false;
                this.changeStatus = true;
                await this.getDetailPlanMaster(golfCourse, ModeStatus);
                if (this.input.validFlag === this.deleteStatus) {
                    this.deleteBtnDisable = true;
                    this.deleteBtnName = '削除済み';
                } else {
                    this.deleteBtnDisable = false;
                    this.deleteBtnName = '削除';
                }
            } else {
                this.addStatus = true;
                this.changeStatus = false;
                this.Initialize();
                this.input.golfCode = golfCourse;
                await this.getAddPlanInfo(golfCourse, ModeStatus);
            }
            this.$refs.form.resetValidation();
        },
        /** ----------------------------------------------
         * モーダル画面を閉じる際の処理
         * ---------------------------------------------- */
        closeModal () {
            if (this.addStatus) {
                if (this.inputChange) {
                    let result = confirm('プラン情報は登録されませんが、閉じますか？');
                    if (result) {
                        this.deletePlanMaster();
                    } else {
                        return;
                    }
                }
            } else if (this.changeStatus) {
                let text = '';
                // if (this.benefitsCount === 0) {
                //     text = text + '特典情報が登録されていません。\n';
                // }
                if (this.feesCount === 0) {
                    text = text + '料金設定が登録されていません。\n';
                }
                if (this.timesCount === 0) {
                    text = text + '枠連携時間設定が登録されていません。\n';
                }
                if (this.inputChange) {
                    // text = text + '変更点がありますが、閉じますか？';
                    text = text + 'プラン情報は更新されませんが、閉じますか？';
                }
                if (text !== '') {
                    let result = confirm(text);
                    if (!result) {
                        return;
                    }
                }
            }
            this.Initialize();
            this.$refs.form.resetValidation();
            this.$emit('close');
        }
    }
};
</script>

<style scoped>
    .v-text-field ::v-deep input[type=number]::-webkit-outer-spin-button,
    .v-text-field ::v-deep input[type=number]::-webkit-inner-spin-button {
        -webkit-appearance: none;
        margin: 0;
    }

    .v-text-field ::v-deep input[type=number] {
        -moz-appearance: textfield;
    }
    .deletebtn {
        background-color: burlywood;
        color: red;
    }
</style>
